// components/ui/button.js
import React from "react";
import { useConfig } from '../../context/ConfigContext';

export function Button({ 
  children, 
  variant = "default", 
  className = "", 
  ...props 
}) {
  const { config } = useConfig();
  
  const getStyles = () => {
    switch(variant) {
      case 'default':
        return {
          backgroundColor: config.colors.primary,
          color: 'white',
          ':hover': {
            backgroundColor: `${config.colors.primary}DD`
          }
        };
      case 'outline':
        return {
          borderColor: `${config.colors.textSecondary}30`,
          color: config.colors.textPrimary,
          ':hover': {
            backgroundColor: `${config.colors.backgroundAlt}`
          }
        };
      case 'destructive':
        return {
          backgroundColor: '#ef4444',
          color: 'white',
          ':hover': {
            backgroundColor: '#dc2626'
          }
        };
      case 'ghost':
        return {
          color: config.colors.textPrimary,
          ':hover': {
            backgroundColor: `${config.colors.backgroundAlt}`
          }
        };
      case 'link':
        return {
          color: config.colors.primary,
          ':hover': {
            color: `${config.colors.primary}DD`
          }
        };
      default:
        return {};
    }
  };
  
  // Keep the original variant classes for non-color properties
  const variantClassBase = {
    default: "",
    outline: "border",
    destructive: "",
    ghost: "",
    link: "underline"
  };
  
  return (
    <button
      className={`px-4 py-2 rounded-md font-medium text-sm transition-colors ${variantClassBase[variant]} ${className}`}
      style={getStyles()}
      onMouseOver={(e) => {
        if (variant === 'default') {
          e.currentTarget.style.backgroundColor = `${config.colors.primary}DD`;
        } else if (variant === 'outline' || variant === 'ghost') {
          e.currentTarget.style.backgroundColor = `${config.colors.backgroundAlt}`;
        } else if (variant === 'destructive') {
          e.currentTarget.style.backgroundColor = '#dc2626';
        } else if (variant === 'link') {
          e.currentTarget.style.color = `${config.colors.primary}DD`;
        }
      }}
      onMouseOut={(e) => {
        if (variant === 'default') {
          e.currentTarget.style.backgroundColor = config.colors.primary;
        } else if (variant === 'outline' || variant === 'ghost') {
          e.currentTarget.style.backgroundColor = '';
        } else if (variant === 'destructive') {
          e.currentTarget.style.backgroundColor = '#ef4444';
        } else if (variant === 'link') {
          e.currentTarget.style.color = config.colors.primary;
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}

// // components/ui/button.js
// import React from "react";

// const variantStyles = {
//   default: "bg-blue-500 text-white hover:bg-blue-600",
//   outline: "border border-gray-300 text-gray-700 hover:bg-gray-50",
//   destructive: "bg-red-500 text-white hover:bg-red-600",
//   ghost: "text-gray-700 hover:bg-gray-100",
//   link: "text-blue-500 underline hover:text-blue-600"
// };

// export function Button({ 
//   children, 
//   variant = "default", 
//   className = "", 
//   ...props 
// }) {
//   return (
//     <button
//       className={`px-4 py-2 rounded-md font-medium text-sm transition-colors ${variantStyles[variant]} ${className}`}
//       {...props}
//     >
//       {children}
//     </button>
//   );
// }